import React from 'react';
import {connect} from "react-redux";
import ExpandingBox from "components/ExpandingBox";
import Button from "components/Button";

import AppInfoTable from "components/app/AppInfoTable";
import AvailableProductsSchoolList from "components/app/info/AvailableProductsSchoolList";

import {getAvailableProducts} from "state/app/selectors"
import {history} from "state/history";

import {openGuide as openTeachersGuide} from "state/teachers/actions";
import {openGuide as openSchoolMoneyGuide} from "state/school_money/actions";

import "./InfoPage.css";

class InfoPage extends React.Component {

  teachersGuideOnClick = event => {
    event.stopPropagation();
    this.props.openTeachersGuide();
    history.push("/teachers/");
  }

  schoolMoneyGuideOnClick = event => {
    event.stopPropagation();
    this.props.openSchoolMoneyGuide();
    history.push("/school_money/");
  }

  render() {

    const teachersGuideButton = <Button className="app-info-teachers-guide__button" onClick={this.teachersGuideOnClick}>View Teachers2Parents Introduction</Button>;
    const schoolMoneyGuideButton = <Button className="app-info-school_money-guide__button" onClick={this.schoolMoneyGuideOnClick}>View SchoolMoney Introduction</Button>;

    const isTeachersAvailable = this.props.availableProducts.includes("teachers");
    const isSchoolMoneyAvailable = this.props.availableProducts.includes("school_money");

    return (
      <div className="info-page">
        <div className="page-header">
          <h1 className="page-header__title">Information</h1>
          <hr />
        </div>

        <div className="info-list">
          <div className="info-list__registered-schools-section">
            <AvailableProductsSchoolList />
          </div>
          <hr className="info-list__subhr" />
          <div className="info-list__app-info-section">

            <div className="app-info-item">
              <ExpandingBox>
                <ExpandingBox.Header toggleOnClick={true}>
                  <h2 className="app-info-item__title">About Us</h2>
                </ExpandingBox.Header>
                <ExpandingBox.Body toggleOnClick={true}>
                  <p>Eduspot is an educational software company that has been providing online solutions for schools country-wide for over a decade.</p>
                  <p>We develop web-based systems that make life easier for both parents and schools alike. The Eduspot brand includes several successful and innovative products such as the messaging service Teachers2Parents, payment system SchoolMoney, and management information system SchoolPod.</p>
                  <div className="app-info-guide-buttons">
                    {isTeachersAvailable ? teachersGuideButton : null}
                    {isSchoolMoneyAvailable ? schoolMoneyGuideButton : null}
                  </div>
                </ExpandingBox.Body>
              </ExpandingBox>
            </div>

            <div className="app-info-item">
              <ExpandingBox>
                <ExpandingBox.Header toggleOnClick={true}>
                  <h2 className="app-info-item__title">App Info</h2>
                </ExpandingBox.Header>
                <ExpandingBox.Body toggleOnClick={true}>
                  <AppInfoTable cssBlockName="app-info-table" />
                </ExpandingBox.Body>
              </ExpandingBox>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => { return {
    availableProducts: getAvailableProducts(state)
  }},
  {
    openTeachersGuide: openTeachersGuide,
    openSchoolMoneyGuide: openSchoolMoneyGuide
  }
)(InfoPage);



// WEBPACK FOOTER //
// ./src/components/app/info/InfoPage.js